import { Box, styled } from '@mui/material';

export const StyledFilterBarBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2)
}));
